<template>
    <div>
        <div class="profile-card">

            <div class="cover-photo">
                <p class="blanco titulo"><span class="rojo">AUDI</span> México</p>
                <img class="navbar-brand-full" src="@/assets/img/Rings_wh.png" alt="Audi logo" />
                <div class="profile-photo-container">
                    <img v-if="!error" :src="logo" alt="Profile photo" class="profile-photo">
                </div>
            </div>
        </div>
        <div class="flex" v-if="!error">
            <p class="bold-small s-15">{{ dataUser.name }} {{ dataUser.lastName }} {{ dataUser.mothersLastName }}</p>
            <button class="ui-action-button max" @click="download">
                Guardar contacto

            </button>
            <p class="bold line-medium s-14"> <img src="../../assets/img/icon/work_24px.png" alt />Audi México S.A. de C.V.</p>
            <p v-if="dataUser.companyRole" class="bold line-medium s-14"> <img src="../../assets/img/icon/job_24px.png" alt />{{
                dataUser.companyRole }}</p>
            <p v-if="dataUser.uo" class="bold line-medium s-14"> <img src="../../assets/img/icon/job_24px.png" alt />{{
                dataUser.uo }}</p>
            <p v-if="dataUser.cellphoneNumber" class="bold line-medium s-14"> <img src="../../assets/img/icon/Phone_24px.png" alt />{{
                dataUser.cellphoneNumber ? dataUser.cellphoneNumber : 'Sin información' }}</p>
            <a :href="linkUser" class="bold line-medium s-14 link"> <img class="ml5" src="../../assets/img/icon/Mail_24px.png" alt />{{
                dataUser.companyEmail }}</a>
            <a target="_blank" href="https://www.audi.com.mx/es/" class="bold line-medium s-14"><img class="ml5" src="../../assets/img/icon/weblink-l.svg" alt />audi.com.mx</a>
            <p class="bold line mt s-14">Boulevard Q5 No. 1</p>
            <p class="bold line s-14"><img src="../../assets/img/icon/ubicacion_24px.png" alt />San José Chiapa, Puebla
            </p>
            <p class="bold line s-14">C.P. 75012 México</p>
        </div>
        <div v-if="error">
            <div class="error">Error en la petición.</div>
        </div>
        <Spinner :show="loading" />
    </div>

</template>

<script>

import API_SERVICE from "@/lib/api/BusinessCard.js";
const api = new API_SERVICE();
import Alert from "@/components/alerts/Alert.vue";
import S3_Handler from "@/lib/api/s3_handler";
export default {
    components: {

    },
    props: ["values", "onChange"],
    data() {
        return {
            logo: "",
            dataUser: [],
            query: "",
            error: false,
            loading: false,
            linkUser:"https://www.audi.com.mx/"
        };
    },

    beforeMount: async function () {
        var linkElement = document.createElement('a');
        linkElement.id = 'link';
        window.document.body.appendChild(linkElement);
        this.query = `${this.$route.params.id}?accessToken=${this.$route.query.accessToken}`;

        try {
            this.loading = true;
            const data = await api.getDataUser(this.query);

            if (data.error) {
                this.error = true;
            } else {
                this.dataUser = data;
                if (data.picture) {
                    const s3 = new S3_Handler();
                    this.logo = s3.getSignedUrl(data.picture);
                    this.linkUser='mailto:'+this.dataUser.companyEmail;
                } else {
                    this.logo = "https://thumbs.dreamstime.com/b/icono-del-perfil-del-placeholder-del-defecto-90197993.jpg";
                }

            }
            this.loading = false;

            //this.$store.commit("global/SET_LOADING", false);
        } catch (err) {
            this.loading = false;
        }

    },

    methods: {

        download: async function () {
            this.loading = true;
            const data = await api.getDataUserDowload(this.query);

            //window.open("data:text/x-vcard;urlencoded," + data);
            /*setTimeout(() => {
                window.open("data:text/x-vcard;urlencoded," + data, '_self');
            })*/
            /*var link = document.getElementById('link');
            link.setAttribute('href', "data:text/x-vcard;urlencoded," + data);
            link.click();*/
            var vcfString = data;
            var blob = new Blob([vcfString], { type: 'text/x-vcard' });
            var downloadUrl = URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "descarga.vcf";
            document.body.appendChild(a);
            a.click();

            this.loading = false;
        },


    },
    computed: {

    },
};
</script>

<style lang="scss">
.profile-card {
    background: white;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 100%;
    overflow: visible;
    animation: fadeIn 1s ease-out;
    position: relative;
}

.cover-photo {
    padding: 0 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 156px;
    background: black;
    position: relative;
}

.profile-photo-container {
    position: absolute;
    width: 170px;
    height: 170px;
    left: 50%;
    top: -10%;
    transform: translate(-50%, 50%);
    z-index: 2;
}

.profile-photo {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 5px solid white;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    object-fit: cover;
    background: white;
}

.profile-info {
    background: white;
    padding: 90px 20px 20px;
    text-align: center;
    border-radius: 0 0 30px 30px;
}

.flex {
    text-align: center;
    margin-top: 115px;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.bold {
    font-weight: 400;
}

.s-15 {
    font-size: 25px;
    @extend %audi-ext-b;
}

.s-14 {
    font-size: 15px;
}

.bold-small {
    font-weight: 600;
}

i {
    margin-right: 5px;
}

.pin {
    margin-right: 5px !important;
}

.line {
    line-height: 2px;
}

.mt {
    margin-top: 30px;
}

.navbar-brand-full {
    width: 100px;
}

.line-medium {

    line-height: 29.28px;
}

.rojo {
    color: #F50537;
}

.blanco {
    color: white;
}

.titulo {
    @extend %audi-ext-b;
    font-size: 24px;
    font-weight: 700;
}

.max {
    width: 211px !important;
    margin: 10px auto;
    margin-bottom: 30px;
    font-weight: 700;

}

p>img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
}

.error {
    color: #F50537;
    @extend %audi-ext-b;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    margin-top: 40px;
}

@media (max-width: 600px) {
    .titulo {
        font-size: 16px;
        font-weight: 700;
    }

    .navbar-brand-full {
        width: 80px;
    }

    .cover-photo {
        padding: 0 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 156px;
        background: black;
        position: relative;
    }

    .profile-photo-container {
        width: 150px;
        height: 150px;
        left: 50%;
        top: 5%;
        transform: translate(-50%, 50%);
        z-index: 2;
    }
}
.link{
    color:#20a8d8
}
.ml5{
    margin-right: 5px;
}
</style>
